//constants action types
export const USER_SIGNED_IN_SUCCESS = "USER_SIGNED_IN_SUCCESS";
export const USER_SIGNED_OUT_SUCCESS = "USER_SIGNED_OUT_SUCCESS";
